import { MEMORY_STORE, QUERY_STRING_STORE } from '@/helpers/constants';
import { getFirstComponentValue } from '@/helpers/utility';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';
import { fetchTenantById } from '../../organization/Configuration/TenantSetting/query-request';

// 1	EMPLOYEE_LOCATIONS
// 2	ROOM_AVAILABILITIES
// 3	PEOPLE_COUNTS
// 4	PERFORMANCES
// 5	ENVIRONMENTS
// 6	MEETING_ROOMS
// 7	DEVICE_STATUS
// 8	MERAKI_LOGGING
// 9	VERKADA_LOGGING
// 10	EMPLOYEE_MANAGEMENTS
// 11	PEOPLE_COUNTS_ANALYSIS
// 12 EMPLOYEE_ATTENDANCE
// 13	SIGNAGE_COMPONENTS
// 14	BCP_OVERVIEW
const NAVIGATION_TYPE = {
  1: '/employee-locations',
  2: '/meeting-room-usage',
  3: '/people-counts',
  4: '/performances',
  5: '/air-quality',
  6: '/meeting-room-outlook-usage',
  7: '/device-status-overview',
  8: '',
  9: '',
  10: '/employee-access-log',
  11: '/people-counts-analysis',
  12: '/employee-attendance',
  13: '/signage-components',
  14: '/bcp-overview',
};

@connect(state => ({
  querystring: state.querystring,
  sessionStore: state.session,
}))
class RedirectPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageNavigate: '',
      isLoading: true,
    };
  }

  async componentDidMount() {
    await this.fetchAndUpdateNavigation();
  }

  async componentDidUpdate(prevProps) {
    const currentTenant = this.props.querystring?.[QUERY_STRING_STORE.SELECT_BOX_TENANT]?.[0];
    const prevTenant = prevProps.querystring?.[QUERY_STRING_STORE.SELECT_BOX_TENANT]?.[0];
    
    if (currentTenant !== prevTenant) {
      await this.fetchAndUpdateNavigation();
    }
  }

  fetchAndUpdateNavigation = async () => {
    try {
      this.setState({ isLoading: true });
      
      // Get tenant ID from query string first, then fall back to session store
      const tenantId = this.props.querystring?.[QUERY_STRING_STORE.SELECT_BOX_TENANT]?.[0] ||
                      this.props.sessionStore?.[MEMORY_STORE.TENANTS]?.[0]?.tenant_id;

      if (!tenantId) {
        this.setState({ isLoading: false });
        return;
      }

      // Fetch fresh tenant data directly from the API
      const tenantInfo = await fetchTenantById({ tenantId });
      const tenant = tenantInfo?.[0];

      if (!tenant || !tenant.components) {
        this.setState({ isLoading: false });
        return;
      }

      const firstValueComponent = getFirstComponentValue(tenant.components, 1);
      this.setState({ 
        pageNavigate: firstValueComponent,
        isLoading: false 
      });
    } catch (error) {
      console.error('Error fetching tenant data:', error);
      // Fallback to session store data if API call fails
      const tenants = this.props.sessionStore[MEMORY_STORE.TENANTS];
      if (tenants && tenants.length > 0) {
        this.updatePageNavigateFromSession({ tenant: tenants[0] });
      }
      this.setState({ isLoading: false });
    }
  };

  updatePageNavigateFromSession = ({ tenant }) => {
    if (!tenant || !tenant.components) {
      return;
    }
    const firstValueComponent = getFirstComponentValue(tenant.components, 1);
    this.setState({ pageNavigate: firstValueComponent });
  };

  render() {
    const { pageNavigate, isLoading } = this.state;
    
    if (isLoading) {
      return <></>;
    }
    
    if (!pageNavigate) {
      return <></>;
    }

    return <Redirect to={NAVIGATION_TYPE[pageNavigate]} exact={true} />;
  }
}

RedirectPage.propTypes = {};

export default RedirectPage;
